import { AxiosInstance } from 'axios'
import { IJsonApiSerializer, IJsonResource, IJsonResponse } from '../JsonApiSerializer'
import { OtaCheckinStatus } from 'static/interfaces'

class OtaReservationService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async update(id, params) {
    const { data } = await this.httpClient.put(`/agent/api/ota_reservations/${id}`, {
      ota_reservation: params,
    })
    const updatedOtaReservation = this.serializer.parseResourceData(
      data.ota_reservation,
      data.ota_reservation.data
    )

    return { updatedOtaReservation, flush: data.flush }
  }

  public async updateMemo(id, params) {
    const { data } = await this.httpClient.patch(`/agent/api/ota_reservations/${id}/memo`, {
      ota_reservation: params,
    })
    const updatedOtaReservation = this.serializer.parseResourceData(
      data.ota_reservation,
      data.ota_reservation.data
    )

    return { updatedOtaReservation, flush: data.flush }
  }

  public async checkIn(id, checkinStatus: OtaCheckinStatus) {
    const { data } = await this.httpClient.put(`/agent/api/ota_reservations/${id}/check_in`, {
      ota_reservation: { checkin_status: checkinStatus },
    })

    return { flush: data.flush }
  }

  public async setPost(id: number, jwtPostId: number) {
    const { data } = await this.httpClient.put(`/agent/api/ota_reservations/${id}/set_post`, {
      jwt_post_id: jwtPostId,
    })
    const updatedOtaReservation = this.serializer.parseResourceData(
      data.ota_reservation,
      data.ota_reservation.data
    )

    return { updatedOtaReservation, flush: data.flush }
  }

  public async setTourDatetime(id: number, params: { tour_date: string; tour_start_at: string }) {
    const { data } = await this.httpClient.put(
      `/agent/api/ota_reservations/${id}/set_tour_datetime`,
      params
    )
    const updatedOtaReservation = this.serializer.parseResourceData(
      data.ota_reservation,
      data.ota_reservation.data
    )

    return { updatedOtaReservation, flush: data.flush }
  }
}

export default OtaReservationService
